(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_carousel-content"] && !Shopify.designMode) return;
  try {
    (function () {
    function initMarquee() {
      document.querySelectorAll('[data-auto-scroll="true"]').forEach(function (wrapper) {
        if (wrapper._marqueeInit) return;
        wrapper._marqueeInit = true;

        const direction = wrapper.dataset.scrollDirection || 'right';
        const speedSetting = parseInt(wrapper.dataset.scrollSpeed, 10) || 30;

        const carouselEl = wrapper.querySelector('.carousel-content');
        const slidesEl = wrapper.querySelector('slideshow-slides');
        if (!carouselEl || !slidesEl) return;

        // Grab the original cards
        const cards = Array.from(slidesEl.children);
        if (cards.length === 0) return;

        // Calculate card width for CSS var
        const firstCard = cards[0];
        const cardWidth = firstCard.offsetWidth;
        const gap = parseInt(getComputedStyle(slidesEl).getPropertyValue('--slideshow-gap') || '8', 10);

        // Build a single track with originals + clones for seamless loop
        const track = document.createElement('div');
        track.classList.add('marquee-track');

        // Original set
        cards.forEach(card => {
          track.appendChild(card);
        });

        // Cloned set (so the loop has content to scroll into)
        cards.forEach(card => {
          const clone = card.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          track.appendChild(clone);
        });

        // Clear slideshow-slides and insert our track
        slidesEl.innerHTML = '';
        slidesEl.appendChild(track);

        // Set CSS vars
        const totalCards = cards.length;
        const totalWidth = (cardWidth + gap) * totalCards;
        const duration = totalWidth / speedSetting; // pixels per second → seconds

        carouselEl.style.setProperty('--marquee-duration', duration + 's');
        carouselEl.style.setProperty('--marquee-card-width', cardWidth + 'px');

        // Apply direction class
        track.classList.add(direction === 'left' ? 'animate-left' : 'animate-right');

        // Mark carousel as marquee mode
        carouselEl.classList.add('is-marquee');
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initMarquee);
    } else {
      initMarquee();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
